import React from 'react'
import Helmet from 'react-helmet'
import { graphql, Link } from 'gatsby'
import Card from '../components/Card'
import Layout from '../layout'
import UserInfo from '../components/UserInfo'
import Disqus from '../components/Disqus'
import PostTags from '../components/PostTags'
import ImageLightBox from '../components/imageLightBox/imageLightBox'
import ShareThisPost from '../components/ShareThisPost'
import SEO from '../components/SEO'
import config from '../../data/SiteConfig'
import './b16-tomorrow-dark.css'
import './post.scss'
import HeroImage from '../components/Blog/HeroImage/HeroImageImage'
import Hero from '../components/BlogPost/Hero'
import BlogNavigate from '../components/BlogNavigate/BlogNavigate'
import TableOfContents from '../components/tableOfContents/tableOfContents'
import ProgressBar from '../components/ProgressBar/ProgressBar'
import * as ReactDOM from 'react-dom'
import VideoEmbed from '../components/VideoEmbed/VideoEmbed'
import Callout from '../components/Blog/Callout'
import VideoInfo from '../components/BlogPost/VideoInfo/VideoInfo'
import _ from 'lodash'

export default class PostTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: true,
      medium: false,
      showSkipTo: false,
      showtableOfContents: false,
      headerOffSet: 0,
      postBodyHeight: 0,
      showLightBox: undefined,
      images: [],
      shouldShowTosButton: false,
      photoIndex: 0,
    }
    this.handleResize = this.handleResize.bind(this)
    this.showSkipTo = this.showSkipTo.bind(this)
    this.setOpen = this.setOpen.bind(this)
  }
  componentDidMount() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)

    setTimeout(() => {
      var addthisScript = document.createElement('script')
      addthisScript.setAttribute(
        'src',
        'https://s7.addthis.com/js/300/addthis_widget.js#pubid=activelamp'
      )
      if (document.body) document.body.appendChild(addthisScript)
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  componentDidUpdate(prevProps) {
    const node = ReactDOM.findDOMNode(this)
    // Get child nodes
    if (node instanceof HTMLElement) {
      const child = node.querySelector('.post-body')
      node.querySelectorAll('.post-body .clearing-thumbs a').forEach(x => {
        const d = document.createElement('div')
        d.innerHTML = x.innerHTML
        x.parentNode.replaceChild(d, x)
      })
      const images = []
      node.querySelectorAll('.post-body img').forEach((x, i) => {
        images.push(x.src)
        x.onclick = () => this.setOpen(true, i)
      })

      if (!_.isEqual(this.state.images, images)) {
        this.setState({ images })
      }
      const headerOffSet =
        window.pageYOffset + child.getBoundingClientRect().top
      const postBodyHeight = child.offsetHeight
      if (
        this.state.headerOffSet !== headerOffSet ||
        this.state.postBodyHeight !== postBodyHeight
      ) {
        this.setState({ headerOffSet, postBodyHeight })
      }
    }

    const shouldShowTosButton =
      new DOMParser()
        .parseFromString(this.props.data.markdownRemark.html, 'text/html')
        .querySelectorAll('h1, h2, h3, h4, h5, h6').length > 0

    if (this.state.shouldShowTosButton !== shouldShowTosButton) {
      this.setState({ shouldShowTosButton })
    }
  }

  handleResize() {
    if (window.innerWidth >= 640) {
      this.setState({ mobile: false, medium: false })
      if (window.innerWidth <= 992) {
        this.setState({ medium: true, mobile: false })
      }
    } else {
      this.setState({ mobile: true, medium: false })
    }
  }

  showSkipTo() {
    this.setState({ showtableOfContents: !this.state.showtableOfContents })
  }

  setOpen(open, i) {
    this.setState({ showLightBox: open, photoIndex: i })
  }

  render() {
    const { mobile, medium } = this.state
    const { pageContext, location } = this.props
    const { slug } = pageContext
    const expanded = !mobile
    const postOverlapClass = mobile ? 'post-overlap-mobile' : 'post-overlap'
    const postNode = this.props.data.markdownRemark
    const post = postNode.frontmatter
    if (!post.id) {
      post.id = slug
    }

    if (!post.category_id) {
      post.category_id = config.postDefaultCategoryID
    }

    return (
      <Layout
        heroType={post.layout === 'video' ? 'video' : null}
        location={this.props.location}
        heroImage={
          post.layout === 'post' ? (
            <HeroImage
              imageUrl={
                post.layout === 'post'
                  ? this.props.data.markdownRemark.frontmatter.assets.hero
                  : null
              }
              postType={post.layout}
            />
          ) : null
        }
        hero={
          post.layout === 'post' ? <Hero blogInfo={this.props.data} /> : null
        }
        postType={post.layout}
      >
        {post.layout === 'post' ? (
          <ProgressBar
            type={`Blog Post • ${this.props.data.markdownRemark.frontmatter.category}`}
            link={`/blog/${this.props.data.markdownRemark.frontmatter.category}`}
            title={this.props.data.markdownRemark.frontmatter.title}
            headerOffSet={this.state.headerOffSet}
            postBodyHeight={this.state.postBodyHeight}
          />
        ) : null}
        {post.layout === 'video' ? <VideoEmbed embed={post.embed} /> : null}
        {post.layout === 'video' ? (
          <VideoInfo videoInfo={this.props.data} />
        ) : null}
        <div className="post-page">
          {post.layout === 'post' && this.state.shouldShowTosButton ? (
            <BlogNavigate showSkipTo={this.showSkipTo}></BlogNavigate>
          ) : null}
          {this.state.showtableOfContents ? (
            <TableOfContents
              showSkipTo={this.showSkipTo}
              content={postNode.html}
            />
          ) : null}
          <Helmet>
            <title>{`${post.title} | ${config.siteTitle}`}</title>
            <link rel="canonical" href={`${config.siteUrl}${post.id}`} />
          </Helmet>
          <ImageLightBox
            photoIndex={this.state.photoIndex}
            images={this.state.images}
            isOpen={this.state.showLightBox}
            setOpen={this.setOpen}
          />
          <SEO postPath={slug} postNode={postNode} postSEO />
          <div className={`post-page-contents ${postOverlapClass}`}>
            <Card className="post">
              <div className="post-body">
                <div dangerouslySetInnerHTML={{ __html: postNode.html }} />
              </div>
              <div className="post-meta">
                <span className="tagged">
                  <i className="fa fa-tag"></i> Tagged
                </span>
                <PostTags tags={post.tags} />
                <div className="see-all-container">
                  <Link to="/rss/feed.xml">
                    Subscribe <i className="fa fa-rss"></i>
                  </Link>
                  <Link to="/blog">
                    See Latest Posts <i className="fa fa-caret-right "></i>
                  </Link>
                </div>
              </div>
            </Card>
            <ShareThisPost
              headerOffSet={this.state.headerOffSet}
              shareUrl={`${config.siteUrl}${post.id}`}
              shareTitle={post.title}
            ></ShareThisPost>
          </div>
          {post.layout === 'video' ? (
            <div className="video-callout--container">
              <Callout />
            </div>
          ) : null}
          <div className={`post-page-contents`}>
            <UserInfo
              config={config}
              author={post.author}
              postNode={postNode}
              expanded={expanded}
            />
            <Disqus postNode={postNode} expanded={expanded} />
          </div>
        </div>
      </Layout>
    )
  }
}

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      excerpt
      frontmatter {
        title
        date
        category
        tags
        embed
        length
        author {
          full_name
          short
          role
          twitter
          github
          email
          image {
            url
          }
        }
        assets {
          hero
        }
        layout
      }
      fields {
        slug
        date
      }
    }
  }
`

// fields {
//   nextTitle
//   nextSlug
//   prevTitle
//   prevSlug
//   slug
//   date
// }
